import React, { useEffect, useState } from 'react';
import { referencesApiService } from '../../services/api';
import { VideoGuide } from '../../types/api';

type GuidesByAudience = { client: VideoGuide[]; partner: VideoGuide[] };

/**
 * Видеоинструкции на странице поддержки (строка 43 QA-таблицы).
 *
 * Список ведёт админ («Коммуникации → Видеоинструкции»); пока роликов нет,
 * блок не показывается вовсе — пустой заголовок выглядел бы как поломка.
 * Якорь `#video` — ссылка из приложения.
 */
export function VideoGuidesSection() {
  const [guides, setGuides] = useState<GuidesByAudience>({ client: [], partner: [] });

  useEffect(() => {
    let cancelled = false;
    Promise.all([
      referencesApiService.getVideoGuides('client').catch(() => []),
      referencesApiService.getVideoGuides('partner').catch(() => []),
    ]).then(([client, partner]) => {
      if (!cancelled) setGuides({ client, partner });
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (guides.client.length === 0 && guides.partner.length === 0) return null;

  return (
    <div className="qp-support-section" id="video">
      <h2>Видеоинструкции</h2>
      <VideoGroup title="Клиентам" guides={guides.client} />
      <VideoGroup title="Партнёрам" guides={guides.partner} />
    </div>
  );
}

function VideoGroup({ title, guides }: { title: string; guides: VideoGuide[] }) {
  if (guides.length === 0) return null;

  return (
    <>
      <p className="qp-video-group">{title}</p>
      <div className="qp-video-grid">
        {guides.map((guide) => (
          <a key={guide.id} href={guide.url} target="_blank" rel="noopener noreferrer" className="qp-video-card">
            {guide.thumbnail && <img src={guide.thumbnail} alt="" loading="lazy" />}
            <span>{guide.title}</span>
          </a>
        ))}
      </div>
    </>
  );
}
